import { render, staticRenderFns } from "./DeliveryShippingCard.vue?vue&type=template&id=d99df7ac&scoped=true&"
import script from "./DeliveryShippingCard.vue?vue&type=script&lang=js&"
export * from "./DeliveryShippingCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryShippingCard.vue?vue&type=style&index=0&id=d99df7ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99df7ac",
  null
  
)

export default component.exports